import api from './api';

export const getSeries = ({ full = false, limit = 20, page = 1, search = '', genre = '' } = {}) =>
  api.get(`/api/v1/series?full=${full}&limit=${limit}&page=${page}&search=${search}&genre=${genre}`);
export const getSerie = (id) => api.get(`/api/v1/series/${id}`);
export const getSerieByUrl = (url) => api.get(`/api/v1/series/${url}?by=url`);
export const getSeriesForSelect = () => api.get('/api/v1/series?include=titulo_original');
export const createSerie = (payload) => api.post('/api/v1/series', payload);
export const updateSerie = (id, payload) => api.patch(`/api/v1/series/${id}`, payload);
export const deleteSerie = (id) => api.delete(`/api/v1/series/${id}`);
export const assignVideoToSerie = (payload) => api.post('/api/v1/series/assign-video', payload);
export const updateSerieEpisodeTime = (serie, time, episode, duration) =>
  api.patch(`/api/v1/series/${serie}/time`, { time, episode, ...(duration ? { duration } : {}) });
export const markEpisodeWatched = (serie, episode) =>
  api.post(`/api/v1/series/${serie}/complete`, { episode });
export const unmarkEpisodeWatched = (serie, episode) =>
  api.delete(`/api/v1/series/${serie}/complete/${episode}`);
export const getRecommendedSeries = () => api.get('/api/v1/series/recommended');
export const getSeriesGenres = () => api.get('/api/v1/genres');
export const getSeriesByGenre = (genreId) => api.get(`/api/v1/series/by-genre/${genreId}`);
